module.exports = __webpack_public_path__ + "Ubuntu-Light.277289c53af7cb469c1d.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-Light.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-Light.ttf
// module chunks = styles